import React from 'react';
import { observer } from 'mobx-react';
import { useLocation } from 'react-router-dom';
import { isMobile } from 'react-device-detect';
import user from 'stores/user';
import Overview from './Overview';
import BlankMain from './BlankMain';
import { Board } from '../styled';
import SocialProfile from '../socialProfile';
import Community from './Community';
// import TaskVerification from './TaskVerification';
import { useScrollToAnchor } from 'hooks/useScrollToAnchor';

const Main = () => {
    const location = useLocation();
    useScrollToAnchor({ block: 'start', offset: isMobile ? -100 : 0, deps: [location.state, location.search] });

    return user.address ? (
        <div>
            <Board>
                <Overview />
                {/* <TaskVerification /> */}
                <SocialProfile />
                <Community />
                {/* <ClaimBTCgas /> */}
            </Board>
        </div>
    ) : (
        <BlankMain />
    );
};

export default observer(Main);
